module.exports = __webpack_public_path__ + "static/media/correct.31f437ca.svg";